<template>
  <div class="voice-recorder display-flex align--center">
    <!--Contenido del audio-->
    <div v-if="isStart" class="voice__container display-flex align--center">
      <!--boton de eliminar audio-->
      <a-tooltip title="Eliminar audio">
        <a-icon
          type="delete"
          @click="handleDelete"
          class="voice__icon voice__icon-delete cursor-pointer"
        />
      </a-tooltip>
      <div class="voice__content">
        <audio v-if="urlAudio" class="voice__audio" controls>
          <source :src="urlAudio" />
        </audio>
        <div v-else class="display-flex align--center">
          <div class="voice__rec blink"></div>
          <span class="voice__timer">{{ timerFormatted }}</span>
          <span class="regular-14 mrg-bottom-0"> Grabando...</span>
        </div>
      </div>
      <!--boton de finalizar audio-->
      <a-tooltip title="Detener">
        <i
          v-if="!urlAudio"
          class="voice__icon anticon voice__icon-end cursor-pointer"
          @click="handleStop"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:height="'24'" v-bind:width="'24'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm20 0a9 9 0 11-18 0 9 9 0 0118 0zm-6-5a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9a2 2 0 012-2h6zm-6 8V9h6v6H9z" fill="currentColor"/></svg>
        </i>
      </a-tooltip>
    </div>
    <!--Boton de comenzar audio-->
    <i
      v-if="!isStart"
      class="voice__icon anticon cursor-pointer voice__icon-start"
      :class="{ 'voice__icon--disabled cursor-not-allowed': disabled }"
      @click="handleStart"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:height="'26'" v-bind:width="'26'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1a4 4 0 014 4v7a4 4 0 01-8 0V5a4 4 0 014-4zm1 18.938V21h3v2H8v-2h3v-1.062A8.001 8.001 0 014 12v-2h2v2a6 6 0 0012 0v-2h2v2a8.001 8.001 0 01-7 7.938zM10 5a2 2 0 114 0v7a2 2 0 11-4 0V5z" fill="currentColor"/></svg>
    </i>
    <!--Boton de enviar audio-->
    <i
      v-else
      class="voice__icon anticon cursor-pointer voice__icon-send"
      @click="handleSendAudio"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:height="'26'" v-bind:width="'26'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.74 2.252l1.365 9.555.772.193-.772.193-1.365 9.555L22.236 12 2.74 2.252zm3.155 7.94L5.26 5.749 17.764 12 5.26 18.252l.635-4.445L13.123 12l-7.228-1.807z" fill="currentColor"/></svg>
    </i>
  </div>
</template>

<script>
import Recorder from 'opus-recorder'
import formatMixin from '@/app/shared/mixins/format'
import { mapActions } from 'vuex'

export default {
  name: 'VoiceRecorder',
  props: {
    onUpload: {
      type: Function,
      required: true,
      default: null,
    },
    disabled: { type: Boolean, required: false, default: false },
  },
  data: () => ({
    recorder: void 0,
    urlAudio: null,
    isStart: false,
    timerSeconds: 0,
    timer: null, // Funcion del timer
    isDeleted: false,
  }),
  mixins: [formatMixin],
  mounted() {
    this.$nextTick(() => this.verifiedRecorder())
  },
  computed: {
    /**
     * Devuelve el tiempo que ha pasado en un formato de texto
     * @return {String} tiempo formateado
     */
    timerFormatted() {
      if (this.timerSeconds < 60)
        return this.timerSeconds < 10
          ? `0:0${this.timerSeconds}`
          : `0:${this.timerSeconds}`
      else if (this.timerSeconds < 3600)
        return `${this.timeFormatted(
          this.timerSeconds,
          'seconds',
          'toMinutes'
        )}`
      else
        return `${this.timeFormatted(this.timerSeconds, 'seconds', 'toHours')}`
    },
  },
  methods: {
    ...mapActions(['uploadFileMessage']),

    /**Verifica que el navegador pueda usar la grabadora */
    verifiedRecorder() {
      if (!navigator.mediaDevices?.getUserMedia)
        return console.error('getUserMedia not supported on your browser!')
      else {
        console.log('getUserMedia supported on your browser')
      }
    },
    /**
     * Comienza a grabar
     */
    handleStart() {
      if (this.disabled) return
      this.$emit('onStart')
      this.isDeleted = false
      this.recorder = new Recorder({
        monitorGain: 0,
        recordingGain: 1,
        numberOfChannels: 1,
        encoderPath:
          'https://cdnjs.cloudflare.com/ajax/libs/opus-recorder/8.0.3/encoderWorker.min.js',
        encoderApplication: 2049,
      })
      this.handleSetStart(true)

      this.startTimer()

      this.recorder.start().catch(function (e) {
        console.warn('error start', e)
      })
    },
    /**
     * Finaliza la grabacion
     * @param {Boolean} forceSend - fuerza a enviar directamente el audio
     */
    handleStop({ forceSend = false } = {}) {
      this.recorder.stop()
      this.stopTimer()
      let self = this
      this.recorder.ondataavailable = async function (typedArray) {
        // si ya esta eliminado no hara nada
        if (self.isDeleted) return
        if (forceSend) self.handleSetStart(false)
        const blob = new Blob([typedArray], {
          type: 'audio/ogg',
        })
        // setear url de audio para la preview
        if (!forceSend) {
          const url = URL.createObjectURL(blob)
          self.urlAudio = url
        }
        const fileName = new Date().toISOString() + '.ogg'
        const file = self.convertToFile({ buffer: typedArray, name: fileName })
        await self.onUpload({ file })
        if (forceSend) {
          self.$emit('onSend')
          self.handleReset()
        }
      }
    },
    /**
     * Convierte un buffer a un archivo
     * @param {Array} buffer - resultado devuelto por la libreria
     * @param {String} name - nombre del archivo
     */
    convertToFile({ buffer, name }) {
      const file = new File([buffer], name, { type: 'audio/ogg' })
      return file
    },
    /**
     * Elimina el audio
     */
    handleDelete() {
      this.isDeleted = true
      this.handleStop()
      this.urlAudio = null
      this.handleSetStart(false)
      this.$emit('onDelete')
    },
    /**
     * Inicia la cuenta del contador
     */
    startTimer(initialTime = 0) {
      this.timerSeconds = initialTime
      this.timer = setInterval(() => {
        this.timerSeconds++
      }, 1000)
    },
    /**
     * Finaliza la cuenta del contador
     */
    stopTimer() {
      clearInterval(this.timer)
      this.timerSeconds = 0
    },
    /**
     * Enviar audio
     */
    handleSendAudio() {
      if (!this.urlAudio) this.handleStop({ forceSend: true })
      else {
        this.$emit('onSend')
        this.handleReset()
      }
    },
    /**
     * Setea valor a isStart
     * @param {Boolean} isStart
     */
    handleSetStart(isStart) {
      this.isStart = isStart
      this.$emit('onChangeStart', isStart)
    },
    /**
     * Resetea todos datos
     */
    handleReset() {
      this.recorder = void 0
      this.urlAudio = null
      this.handleSetStart(false)
      this.timerSeconds = 0
      this.timer = null // Funcion del timer
      this.isDeleted = false
      this.stopTimer()
    },
  },
}
</script>

<style lang="sass" scoped>
.voice
  &-recorder
    padding: 4px 0px
    height: 40px
  &__container
    margin: 0px 12px
  &__icon
    font-size: 24px
    &-start
      color: $gray_dark_700
      font-size: 26px
    &-end
      color: $red_6
      margin-left: 12px
    &-delete
      color: $gray_dark_900
      margin-right: 12px
    &-send
      color: $gray_dark_700
    &--disabled
      color: $gray_6
  &__rec
    height: 12px
    width: 12px
    border-radius: 50%
    background-color: $red_6
    margin-right: 8px
  &__timer
    margin-right: 12px
  &__content
    color: $gray_dark_900
    max-height: 43px
  &__audio
    height: 43px

.blink
  animation-name: blinking
  animation-duration: 1s
  animation-timing-function: linear
  animation-iteration-count: infinite

  -webkit-animation-name:blinking
  -webkit-animation-duration: 1s
  -webkit-animation-timing-function: linear
  -webkit-animation-iteration-count: infinite

@keyframes blinking
  0%
    opacity: 1.0
  50%
    opacity: 0.0
  100%
    opacity: 1.0
</style>
